import {
  createContext,
  useContext,
  type ComponentType,
  type ReactElement,
} from 'react';

import type { KeyName } from '@/lib/key';

export type KeyTooltipProps = {
  label: string;
  keys?: readonly KeyName[];
};

export type KeyTooltip = ComponentType<
  KeyTooltipProps & { children: ReactElement }
>;

// Set by a host that draws Chat and Dismiss as icons beside the primary, each naming itself and its key in the
// host's own tooltip
export const HostIconActionsContext = createContext<KeyTooltip | null>(null);

export const useHostIconActions = () => useContext(HostIconActionsContext);
